export const flowTaskTabNames = {
  // -- TAB: Task Identity
  TASK_ASSIGN: 'task_assign',

  // -- TAB: Parameters
  ABOUT: 'about',
  PARAMETERS: 'parameters',
  INTERACTION: 'interaction',
  GEOGRAPHY: 'geography',

  // -- TAB: Interaction
  INTERACTION_CONDITIONS: 'conditions',
  INTERACTION_RESOURCES: 'resources',
  INTERACTION_VARIABLES: 'variables'
}
